import type { ElementType } from 'react';
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Payment as PaymentIcon,
  Receipt as ReceiptIcon,
  Assessment as ReportIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

export interface PrimaryNavItem {
  text: string;
  path: string;
  icon: ElementType;
}

/** Five primary destinations for bottom navigation (FR-003). Settings is excluded (FR-004). */
export const primaryNavItems: PrimaryNavItem[] = [
  { text: 'Dashboard', path: '/', icon: DashboardIcon },
  { text: 'Residents', path: '/residents', icon: PeopleIcon },
  { text: 'Payments', path: '/payments', icon: PaymentIcon },
  { text: 'Expenses', path: '/expenses', icon: ReceiptIcon },
  { text: 'Reports', path: '/reports', icon: ReportIcon },
];

/** Sidebar drawer includes Settings after primaries. */
export const settingsNavItem: PrimaryNavItem = {
  text: 'Settings',
  path: '/settings',
  icon: SettingsIcon,
};

export const drawerNavItems: PrimaryNavItem[] = [...primaryNavItems, settingsNavItem];

/** Match route for drawer / bottom nav selection (flat paths). */
export function matchesNavPath(itemPath: string, pathname: string): boolean {
  if (itemPath === '/') {
    return pathname === '/' || pathname === '';
  }
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
}
